module.exports = __webpack_public_path__ + "img/bid-open-hall-right.54758af7.png";